import { numeroALetras } from "../../../../../helpers/utils/CurrencyConverter";
import { reportHeaderImg1, reportHeaderImg2 } from "../beneficiaries_report/reportAssets";


export const BalanceInFavorReport = ({dataReport}) => {

    // Obtener la fecha actual
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.toLocaleString('es-CO', { month: 'long' }); // p. ej. "septiembre"
    const year = currentDate.getFullYear();

    const img1 = reportHeaderImg1
    const img2 = reportHeaderImg2


    // Calcula la diferencia y la redondea al peso más cercano
    const bruto = (Number(dataReport?.saldo) || 0) - (Number(dataReport?.invertido) || 0);

    // Nunca negativo, y redondeado a pesos
    const valor = Math.max(0, Math.round(bruto));

    // Formato $ 1.234 (sin decimales)
    const valorFormateado = valor.toLocaleString('es-CO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    const valorEnLetras = numeroALetras(valor).toUpperCase(); // en mayúsculas
    // Sugerencia típica para dinero en Colombia:
    const leyendaLetras = `${valorEnLetras} PESOS M/CTE`;


    return (
        <>
            <div id="report-section">
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                        <tr>
                            <td style={{ width: '15%', textAlign: 'center', borderTop: '1px solid black', borderLeft: '1px solid black', borderRight: '1px solid black' }}>
                                <img src={img1} alt="" style={{ height: '60px' }} />
                            </td>
                            <td style={{ width: '70%', borderTop: '1px solid black', textAlign: 'center' }}>
                                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                    <tbody>
                                    <tr>
                                        <td colSpan="4" style={{ borderBottom: '1px solid black', textAlign: 'center', padding: '5px' }}>AGENCIA DE RENOVACIÓN DEL TERRITORIO DIRECCIÓN DE SUSTITUCIÓN DE CULTIVOS DE USO ILÍCITO</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="4" style={{ borderTop: '1px solid black', borderBottom: '1px solid black', textAlign: 'center', padding: '5px' }}>CONSENTIMIENTO EXPRESO E INFORMADO PARA LA REASIGNACIÓN DE SALDOS REMANENTES INEJECUTABLES, CORRESPONDIENTES A LOS COMPONENTES DE PROYECTOS PRODUCTIVOS DE CICLO CORTO Y CICLO LARGO EN EL MARCO DEL PROGRAMA PNIS</td>
                                    </tr>
                                    <tr>
                                        <td style={{ borderRight: '1px solid black', textAlign: 'center', padding: '5px' }}>DIRECCIÓN DE SUSTITUCIÓN DE CULTIVOS DE USO ILICITO</td>
                                        <td style={{ width: '15%', borderRight: '1px solid black', textAlign: 'center', padding: '5px' }}>Código:</td>
                                        <td style={{ borderRight: '1px solid black', textAlign: 'center', padding: '5px' }}>Versión: preliminar</td>
                                        <td style={{ textAlign: 'center', padding: '5px' }}>Fecha de publicación: preliminar</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td style={{ width: '30%', textAlign: 'center', borderTop: '1px solid black', borderLeft: '1px solid black', borderRight: '1px solid black' }}>
                                <img src={img2} alt="" style={{ height: '60px' }} />
                            </td>
                        </tr>
                    </thead>
                </table>

                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <thead>
                        <tr>
                            <td style={{ textAlign: "center", border: "1px solid black" }}>
                                <h4>OBJETO</h4>
                            </td>
                        </tr>
                    </thead>
                </table>

                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <thead>
                        <tr>
                            <td
                                style={{
                                    borderLeft: "1px solid black",
                                    borderRight: "1px solid black",
                                    textAlign: "justify",
                                    padding: "8px",
                                }}
                            >
                                Con el diligenciamiento del presente instrumento se formaliza el
                                consentimiento expreso, inequívoco, informado e irrevocable del
                                titular del núcleo familiar beneficiario vinculado al Programa
                                Nacional Integral de Sustitución de Cultivos de Uso Ilícito (PNIS)
                                para la renuncia, y posterior reasignación definitiva hacia el
                                componente de Asistencia Técnica Integral (ATI), de los saldos que
                                quedaran pendientes de entrega en el marco de la implementación de su
                                proyectos productivos (de ciclo corto, largo o renegociados),{" "}
                                <strong>
                                    cuando, en atención a su cuantía, resultan materialmente
                                    inejecutables, toda vez que no son suficientes para destinarse a la
                                    adquisición de ningún bien o servicio en el marco de las ferias de
                                    proveedores.
                                </strong>
                            </td>
                        </tr>
                        <tr>
                            <td
                                style={{
                                    borderLeft: "1px solid black",
                                    borderRight: "1px solid black",
                                    textAlign: "justify",
                                    padding: "8px",
                                }}
                            >
                                Así, la formalización del consentimiento por parte del beneficiario
                                del programa PNIS resulta un requisito indispensable para efectos de
                                la determinación posterior de la terminación formal de la vinculación
                                del titular frente a los compromisos derivados de la implementación
                                del programa. En este sentido, la identificación precisa de estos
                                saldos y su registro mediante el presente instrumento asegura la
                                transparencia, trazabilidad y responsabilidad en la administración de
                                los recursos públicos, en consonancia con los principios de
                                publicidad, moralidad y buena fe que rigen la función administrativa.
                            </td>
                        </tr>
                        <tr>
                            <td
                                style={{
                                    borderLeft: "1px solid black",
                                    borderRight: "1px solid black",
                                    textAlign: "justify",
                                    padding: "8px",
                                }}
                            >
                                Una vez determinados y consolidados los saldos remanentes, con la
                                suscripción de este instrumento el titular PNIS identificado/a más
                                adelante acepta que los saldos de su CUB aquí señalados sean
                                reorientados globalmente al componente de Asistencia Técnica Integral
                                (ATI), en aplicación de los principios de eficiencia, eficacia y
                                economía previstos en el artículo 3 del Código de Procedimiento
                                Administrativo y de lo Contencioso Administrativo (CPACA), con el fin
                                de fortalecer las acciones de acompañamiento técnico a los
                                beneficiarios del programa y optimizar así el impacto del PNIS
                                mediante el uso racional, transparente y justificado de los recursos
                                no ejecutados, en estricto cumplimiento de los lineamientos
                                normativos y operativos vigentes.
                            </td>
                        </tr>
                    </thead>
                </table>

                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <thead>
                        <tr>
                            <td style={{ textAlign: "center", border: "1px solid black" }}>
                                <h4>MANIFESTACIÓN DE RENUNCA Y REASIGNACIÓN DE RECURSOS DEL CUB EN EL PNIS</h4>
                            </td>
                        </tr>
                    </thead>
                </table>

                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <thead>
                        <tr>
                            <td
                                style={{
                                    borderLeft: "1px solid black",
                                    borderRight: "1px solid black",
                                    textAlign: "justify",
                                    padding: "8px",
                                }}
                            >
                                Yo, <strong>{dataReport?.nombre}</strong>,
                                identificado(a) con la cédula de ciudadanía No. <strong>{dataReport?.cedula}</strong>,
                                titular del núcleo familiar beneficiario del Programa Nacional Integral de Sustitución de Cultivos de Uso Ilícito PNIS,
                                identificado mediante el Código Único de Beneficiario (CUB) No. <strong>{dataReport?.cub_id}</strong>, en nombre propio y en representación de mi núcleo familiar,
                                manifiesto de manera libre, expresa, voluntaria e informada mi decisión de renunciar y reasignar, de forma global,
                                al componente de Asistencia Técnica Integral (ATI) el saldo remanente a mi favor que se encuentra registrado en las bases de datos del Programa,
                                por valor de: <strong>$ {valorFormateado}</strong>, <strong>{leyendaLetras}</strong>.
                                Lo anterior, en atención a que,  durante la ejecución de los componentes de ciclo corto y de ciclo largo renegociados en aplicación de lo dispuesto en el
                                artículo 10 de la Ley 2294 de 2023 y en la Resolución 0021 de 2024, mediante las ferias agropecuarias y no agropecuarias
                                desarrolladas por la DSCI en las cuales se consolidaron las órdenes de compra correspondientes a mi línea productiva, se generaron
                                valores inejecutables en razón de su cuantía, resultando imposible su ejecución en el esquema de implementación definido por el Programa.
                            </td>
                        </tr>
                        <tr>
                            <td
                                style={{
                                    borderLeft: "1px solid black",
                                    borderRight: "1px solid black",
                                    textAlign: "justify",
                                    padding: "8px",
                                }}
                            >
                                En consecuencia, autorizo que el saldo remanente del CUB de mi núcleo familiar, pendiente de ejecución,
                                sea descontado de manera definitiva y adicionado al componente de Asistencia Técnica Integral (ATI) del Programa,
                                con el fin de culminar el proceso de intervención y determinar la posterior finalización de mi vinculación con el PNIS.
                            </td>
                        </tr>
                        <tr>
                            <td
                                style={{
                                    borderLeft: "1px solid black",
                                    borderRight: "1px solid black",
                                    textAlign: "justify",
                                    padding: "8px",
                                }}
                            >
                                De esta manera, los recursos destinados a estas labores serán administrados de acuerdo con las condiciones y
                                requisitos establecidos por la Dirección de Sustitución de Cultivos de Uso Ilícito (DSCI), de la Agencia de
                                Renovación del Territorio (ART), para el apoyo permanente a la implementación de los proyectos productivos.
                            </td>
                        </tr>
                        <tr>
                            <td
                                style={{
                                    borderLeft: "1px solid black",
                                    borderRight: "1px solid black",
                                    textAlign: "justify",
                                    padding: "8px",
                                }}
                            >
                                En constancia de lo anterior, firmo la presente declaración el día <strong>{day}</strong> del mes <strong>{month}</strong> del año <strong>{year}</strong>,
                                en el municipio de {dataReport?.municipio}, vereda (si aplica) {dataReport?.vereda}, del departamento de {dataReport?.departamento}.
                            </td>
                        </tr>
                    </thead>
                </table>

                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <thead>
                        <tr>
                            <td style={{ textAlign: "center", border: "1px solid black" }}>
                                <h4>OOBSERVACIONES (SI APLICA)</h4>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: "center", border: "1px solid black" }}>
                                <h4>&nbsp;</h4>
                            </td>
                        </tr>
                    </thead>
                </table>

                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                        <tr>
                            <td style={{ width: '10%', height: '100px', textAlign: 'left', borderLeft: '1px solid black', borderRight: '1px solid black', verticalAlign: 'bottom' }} colSpan={3}>Firma del titular:</td>
                            <td style={{ width: '8%', textAlign: 'left', borderRight: '1px solid black', verticalAlign: 'bottom' }} colSpan={2}>Huella del titular:</td>
                            <td style={{ width: '10%', textAlign: 'left', borderRight: '1px solid black', verticalAlign: 'bottom' }} colSpan={3}>Firma del tecnico:</td>
                        </tr>
                        <tr>
                            <td style={{ width: '10%', textAlign: 'left', border: '1px solid black' }}>Nombre del titular:</td>
                            <td style={{ width: '10%', textAlign: 'left', border: '1px solid black' }}>{dataReport?.nombre}</td>
                            <td style={{ width: '10%', textAlign: 'left', border: '1px solid black' }}>C.C: {dataReport?.cedula}</td>
                            <td style={{ width: '10%', textAlign: 'left', border: '1px solid black' }}>Nombre del técnico:</td>
                            <td style={{ width: '10%', textAlign: 'left', border: '1px solid black' }} colSpan={3}>&nbsp;</td>
                        </tr>
                        <tr>
                            <td style={{ width: '10%', textAlign: 'left', border: '1px solid black' }}>Lugar y fecha de las firmas:</td>
                            <td style={{ width: '10%', textAlign: 'left', border: '1px solid black' }} colSpan={2}>&nbsp;</td>
                            <td style={{ width: '10%', textAlign: 'left', border: '1px solid black' }}>Tarjeta profesional:</td>
                            <td style={{ width: '10%', textAlign: 'left', border: '1px solid black' }}>&nbsp;</td>
                            <td style={{ width: '10%', textAlign: 'left', border: '1px solid black' }}>Cédula del técnico:</td>
                            <td style={{ width: '10%', textAlign: 'left', border: '1px solid black' }}>&nbsp;</td>
                        </tr>
                    </thead>
                </table>

            </div>

        </>
    )
}

